<div class="infobooth-edit-dialog-container" *ngrxLet="selectedInfobooth$ | async as selectedInfobooth">
  <div class="gb-dialog-header edit-infobooth-toolbar">
    <h1>
      {{ dialogData.title || 'SETTINGS.INFOBOOTH.EDIT' | translate }}
    </h1>
    <button mat-icon-button (click)="closeDialog()">
      <gb-icon icon="close"></gb-icon>
    </button>
  </div>
  <div class="gb-dialog-content">
    <form [formGroup]="editInfoboothForm">
      <gb-form-field
        [control]="name"
        labelTranslateKey="SETTINGS.INFOBOOTH.NAME"
        hintTranslateKey="SETTINGS.INFOBOOTH.NAME_TOOLTIP"
      ></gb-form-field>
      <div #infoboothContentQuillContainer>
        <gb-quill-editor
          [bounds]="infoboothContentQuillContainer"
          formControlName="content"
          name="infoboothContent"
        ></gb-quill-editor>
      </div>
    </form>
  </div>
  <div class="gb-flex-button-container gb-dialog-actions-container">
    <button (click)="submitForm()" mat-flat-button>
      <gb-button-loader [loaded$]="editCreateLoaded$">
        {{ dialogData.submitLabel || 'SAVE' | translate }}
      </gb-button-loader>
    </button>
  </div>
</div>
